<template>
    <div>
        <div class="product_menu">
            <dl class="pageCenter" id="product_menu">
                <dt><a href="#page1" title="唐麦耳机A7">Tangmai A7</a></dt>
                <dd data-menuanchor="page2"><a href="#page2">概览</a></dd>
                <dd data-menuanchor="page3"><a href="#page3">音质</a></dd>
                <dd data-menuanchor="page4"><a href="#page4">设计</a></dd>
                <dd data-menuanchor="page5"><a href="#page5">性能</a></dd>
                <dd data-menuanchor="page6"><a href="#page6">体验</a></dd>
                <dd data-menuanchor="page7"><a href="#page7">品质</a></dd>
                <dd data-menuanchor="page8"><a href="#page8">参数</a></dd>
            </dl>
        </div>
        <div id="product" style="z-index:1;" v-if="platform == 1">
            <!-- 头部 -->
            <div class="section header active fp-auto-height">
                <v-header></v-header>

                <div class="product_menu2">
                    <dl class="pageCenter">
                        <dd data-menuanchor="page2"><a href="#page2">概览</a></dd> 
                        <dd data-menuanchor="page3"><a href="#page3">音质</a></dd>
                        <dd data-menuanchor="page4"><a href="#page4">设计</a></dd>
                        <dd data-menuanchor="page5"><a href="#page5">性能</a></dd>
                        <dd data-menuanchor="page6"><a href="#page6">体验</a></dd>
                        <dd data-menuanchor="page7"><a href="#page7">品质</a></dd>
                        <dd data-menuanchor="page8"><a href="#page8">参数</a></dd>
                    </dl>
                </div>
            </div>

            <div class="section product_li" style=" background:url(http://ww1.sinaimg.cn/large/0067mezugw1f9f5y4h1e5j33io1407wi.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww4.sinaimg.cn/large/0067mezugw1f9f5y5br2wj30gk04wmxp.jpg" height="110" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww4.sinaimg.cn/large/0067mezugw1f9f5ybcr7mj33io140kjl.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww2.sinaimg.cn/large/0067mezugw1f9f5yc3y1yj30lt05674u.jpg" height="110" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww1.sinaimg.cn/large/0067mezugw1f9f5ycv0ebj33io140apu.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww3.sinaimg.cn/large/0067mezugw1f9f5ydehccj30mg04qwf5.jpg" height="110" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww4.sinaimg.cn/large/0067mezugw1f9jkvfbm2ij33io140gzy.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww3.sinaimg.cn/large/0067mezugw1f9f5yempx1j30rx05pdgi.jpg" height="130" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww1.sinaimg.cn/large/0067mezugw1f9f5yfgyrsj33io140tef.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww1.sinaimg.cn/large/0067mezugw1f9f5yfyy5hj30nm05daap.jpg" height="110" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww1.sinaimg.cn/large/0067mezugw1f9f5yh2r14j33ip141qv5.jpg) center; background-size:auto 100%;">
            <p class="p1"><img src="http://ww2.sinaimg.cn/large/0067mezugw1f9f5yhrai3j30nx04bq3f.jpg" height="110" /></p>
        </div>
        <div class="section product_li" style=" background:url(http://ww3.sinaimg.cn/large/0067mezugw1f9f5yi97haj33ip1410x3.jpg) center; background-size:auto 100%;">
            <div class="pageCenter">
            	<p style=" top:20%; text-align:left; width:100%;"><img src="http://ww1.sinaimg.cn/large/0067mezugw1f9g8ttg5csj308v030t8z.jpg" height="66" /></p>
				<div class="product_data">
                	<ul>
                    	<li class="left">
                        	<div class="data_box"><p class="data_p1">频响范围</p>
                        	<p class="data_p2">Frequency range</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">20-20000HZ</p>
                            <p class="data_p2">20-20000HZ</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">阻抗</p>
                        	<p class="data_p2">Impedance</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">16Ω+16Ω</p>
                            <p class="data_p2">16Ω+16Ω</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">接口类型</p>
                        	<p class="data_p2">Interface type</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">3.5mm插头</p>
                            <p class="data_p2">3.5mm plug</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">声压</p>
                        	<p class="data_p2">Sound pressure</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">96db</p>
                            <p class="data_p2">96db</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">驱动单元</p>
                        	<p class="data_p2">Drive unit</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">6mm+8mm</p>
                            <p class="data_p2">6mm+8mm</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">线长</p>
                        	<p class="data_p2">Line length</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">1.2m</p>
                            <p class="data_p2">1.2m</p>
                            </div>
                        </li>
						
						<li class="left">
                        	<div class="data_box"><p class="data_p1">灵 敏 度</p>
                        	<p class="data_p2">Sensitivity degree</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">108db</p>
                            <p class="data_p2">108db</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">线材</p>
                        	<p class="data_p2">Wire rod</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">圆线</p>
                            <p class="data_p2">Round line</p>
                            </div>
                        </li>
						<li class="left">
                        	<div class="data_box"><p class="data_p1">是否线控</p>
                        	<p class="data_p2">Whether by wire</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">是</p>
                            <p class="data_p2">yes</p>
                            </div>
                        </li>
						<li>
                        	<div class="data_box"><p class="data_p1">指向</p>
                        	<p class="data_p2">Point</p>
                        	</div>
                            <div class="data_box"><p class="data_p1">全指向</p>
                            <p class="data_p2">Full point</p>
                            </div>
                        </li>
                    </ul>
                </div>
				
            </div>
        </div>

            <!-- 尾部 -->
            <div class="section fp-auto-height fp-section">
                <v-footer></v-footer>
            </div>
            
        </div>

        <div id="mobile" v-else>
            <!--手机端头部-->
            <v-header></v-header>
            <div class="mobile_pageMain">
                <div class="tools">
                    <span class="span1">产品</span>
                    <span class="span2">唐麦 A7</span>
                </div>
                <img class="productImg" style="margin-top:40px;" src="http://ww2.sinaimg.cn/large/0067mezugw1f9g8xs9rtpj30k00frgrh.jpg" />
                <img class="productImg" src="http://ww4.sinaimg.cn/large/0067mezugw1f9g8xt7muhj30k00fsaf5.jpg" />
                <img class="productImg" src="http://ww2.sinaimg.cn/large/0067mezugw1f9ga0qm9wqj30k00fsn0w.jpg" />
                <img class="productImg" src="http://ww2.sinaimg.cn/large/0067mezugw1f9g8xtrw3zj30k00fsjt7.jpg" />
                <img class="productImg" src="http://ww4.sinaimg.cn/large/0067mezugw1f9g8xvife3j30k00fsdhu.jpg" />
                <img class="productImg" src="http://ww1.sinaimg.cn/large/0067mezugw1f9g8xvfiu5j30k00fstcz.jpg" />
                <img class="productImg" src="http://ww4.sinaimg.cn/large/0067mezugw1f9g8xvpstyj30k008dwg1.jpg" />
                <img class="productImg" src="http://ww2.sinaimg.cn/large/0067mezugw1f9g8xw6a34j30k00kjn0c.jpg" />
            </div>
            <v-footer></v-footer>
        </div>
        <!-- 回到顶部 -->
        <a href="#page1"><goto-top></goto-top></a>
    </div>
</template>
<script>
//引入fullpage
import "../../assets/libs/fullpage/jquery.fullPage.css"
import "../../assets/libs/fullpage/jquery.fullPage.min.js"
import "../../assets/css/style.css"
    export default{
        data(){
            return {
                platform: 1   //1 pc端   2 mobile端
            }
        },
        mounted(){
            if($(window).width() > 786){
                this.platform = 1;
                var $mlNav = $('.product_menu');
                $('#product').fullpage({
                    verticalCentered: !1,
                    navigation: !0,
                    anchors: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10'],
                    menu: '#product_menu',
                    onLeave: function(index, nextIndex, direction){
                        if(index == 2 && direction == 'up'){
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        } else if(index == 1 && direction == 'down') {
                            $mlNav.animate({
                                top: 0
                            }, 500);
                            $(".headmenu_two").hide();
                        }
                        if(nextIndex == 1){
                            $mlNav.animate({
                                top: -100
                            }, 0);
                        }
                        if(nextIndex == 10){
                            $mlNav.hide();
                        }else{
                            $mlNav.show();
                        }
                    },
                    afterLoad: function(anchorLink, index){
                        //$(".product_li").css("height", $("#product").height());
                        if(index == 10){
                            $(".product_menu dt a").css("color","#ffffff");
                            $(".product_menu dd a").css("color","#ffffff");
                            $(".product_menu dd.active a").css("color","#000000");
                            $(".product_menu dt a").mouseover(function(){
                                $(this).css("color","#000000");
                            });
                            $(".product_menu dd a").mouseover(function(){
                                $(this).css("color","#000000");
                            });
                            $(".product_menu dt a").mouseleave(function(){
                                $(this).css("color","#ffffff");
                            });
                            $(".product_menu dd a").mouseleave(function(){
                                $(this).css("color","#ffffff");
                            });
                        }else if(index == 3 || index == 4 || index == 6){
                            $(".product_menu dt a").css("color","#9e9e9f");
                            $(".product_menu dd a").css("color","#9e9e9f");
                            $(".product_menu dd.active a").css("color","#000000");
                            $(".product_menu dt a").mouseover(function(){
                                $(this).css("color","#000000");
                            });
                            $(".product_menu dd a").mouseover(function(){
                                $(this).css("color","#000000");
                            });
                            $(".product_menu dt a").mouseleave(function(){
                                $(this).css("color","#9e9e9f");
                            });
                            $(".product_menu dd a").mouseleave(function(){
                                $(this).css("color","#9e9e9f");
                            });
                        }else{
                            $(".product_menu dt a").css("color","#9e9e9f");
                            $(".product_menu dd a").css("color","#9e9e9f");
                            $(".product_menu dd.active a").css("color","#ffffff");
                            $(".product_menu dt a").mouseover(function(){
                                $(this).css("color","#ffffff");
                            });
                            $(".product_menu dd a").mouseover(function(){
                                $(this).css("color","#ffffff");
                            });
                            $(".product_menu dt a").mouseleave(function(){
                                $(this).css("color","#9e9e9f");
                            });
                            $(".product_menu dd a").mouseleave(function(){
                                $(this).css("color","#9e9e9f");
                            });
                            
                        }

                        /*回到顶部*/
                        if(index == 1 || index == 2){
                            $(".gotoTop").hide();
                        }else{
                            $(".gotoTop").show();
                        }
                    }
                })
            }else{
                this.platform = 2;
            }
        },
        destroyed(){
            var html = document.querySelector("html");
            var width = html.getBoundingClientRect().width;
            //设置 1rem = width/16
            if(width >= 768){
                //去除fullpage插件设置的100%高度和隐藏溢出
                $("html, body").removeAttr("style");
                $("html, body").removeAttr("class");
            }
        }
    }
</script>
<style scoped>
@media (min-width: 768px){
    .header-wrap{
        position: relative !important;
    }
}
    

    
</style>


// WEBPACK FOOTER //
// src/pages/products/a7.vue